export default {
  FETCH_AUTH_DATA_PROGRESS: 'auth/fetch_data_progress',
  FETCH_AUTH_DATA_SUCCESS: 'auth/fetch_data_success',
  FETCH_AUTH_DATA_FAILED: 'auth/fetch_data_failed',
  AUTH_CART_COUNT: 'auth/set_cart_count',
  AUTH_WISHLIST_ADD: 'auth/add_to_wishlist',
  AUTH_WISHLIST_REMOVE: 'auth/remove_from_wishlist',
  LOGOUT: 'auth/logout',
  WISHLIST_ITEMS_SUCCESS: 'auth/wishListIdsSuccess',
  LOGOUT_ALL: 'auth/logoutFromAllSession',
  FETCH_USER_DATA_HASH: 'userHash/fetch_user_hash_progress',
  FETCH_USER_DATA_HASH_SUCCESS: 'userHash/fetch_user_hash_success',
  FETCH_USER_DATA_HASH_FAILED: 'userHash/fetch_user_hash_failed',
  USER_DETAILS_FETCHED: 'user/fetch_user_data_success',
  USER_DETAILS_PROGRESS: 'user/fetch__user_data_progress',
  USER_DETAILS_FAILED: 'user/fetch_user_data_failed',
  SET_IOC_VALUE: 'user/iocValue',
};
